<script lang="ts">
	import { Icon, Text } from '@Shelly/shelly-design-system';
	import { classMap } from '@Shelly/shelly-design-system/helpers/component-utils';
	import { openExternalLink } from 'src/helpers/utilities';
	import { user_data } from 'src/stores/account/user';
	import { format } from 'svelte-i18n';

	const list = {
		title: $format('text_title_no_sensors', {
			default: 'No sensors in this room.',
		}),
		description: {
			instruction: $format('text_description_instruction', {
				default: 'You can move a sensor from another room',
			}),
			separator: $format('text_description_separator', { default: 'or' }),
			alternative: $format('text_description_alternative', {
				default: 'to get a new one.',
			}),
		},
		icon: 'fa-regular fa-arrow-up-right-from-square',
		href: `https://www.shelly.cloud/en/products/shop?origin=shelly_app&shelly_user=${$user_data.email}#43e73c569e094a20aabe8d83a5f2426d`,
		linkText: $format('text_link_visit_store', { default: 'visit our store' }),
	};
</script>

<div class="text-center">
	<Text class="mb-m text-center" styleType="h1">{list.title}</Text>
	<Text class="mb-s text-color-muted" styleType="body">{list.description.instruction}</Text>
	<Text class="text-bold mb-s" styleType="body">
		{list.description.separator}
	</Text>

	<Text class={classMap({ 'text-center': true, 'text-color-muted': true })}>
		<Text class="text-color-muted">
			<Icon size="s" class="text-primary" icon={list.icon} />
			<span role="none" class=" link-styles" on:click={() => openExternalLink(list.href)}
				>{list.linkText}</span
			>
			{list.description.alternative}
		</Text>
	</Text>
</div>
